import { createConfiguredApiInstance } from '../utils/axios-factory';

const api = createConfiguredApiInstance({
  baseURL: process.env.NEXT_PUBLIC_BACKEND_URL!,
});

export default api;
